import { useState } from "react";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import Button from "../../Button/Button";
import ChevronUpIcon from "../../../icons/ChevronUp";
import ChevronDownIcon from "../../../icons/ChevronDown";

interface SidebarLinkProps {
    linkType: "a" | "button";
    href?: string;
    title: string;
    icon: React.ReactElement;
    dropdown?: React.ReactNode;
    onClick?: () => void;
    isAllowedToView: boolean;
}

export default function SidebarLink({
    linkType,
    href,
    title,
    icon,
    dropdown,
    onClick,
    isAllowedToView,
}: SidebarLinkProps) {
    const [isOpen, setIsOpen] = useState(false);

    if (!isAllowedToView) {
        return null;
    }

    if (linkType === "button") {
        return (
            <li
                className={`last:mb-0 ${isOpen ? "mb-0" : "mb-2"} ${
                    isOpen
                        ? "bg-[--bg-sidebar-dropdown-open] rounded-md rounded-bl-md rounded-br-md"
                        : "bg-transparent"
                }`}
            >
                <Button
                    type="button"
                    size="auto"
                    mode="transparent"
                    onClick={() => {
                        setIsOpen((state) => !state);
                        onClick?.();
                    }}
                    className="
                        h-8 px-6 flex items-center rounded-md w-full  hover:text-[--sidebar-link-hover-text] !text-base gap-x-1 sidebarlink-hover font-medium justify-start text-[--sidebar-link-text]"
                >
                    {icon}
                    {title}
                    <span className="ml-auto flex items-center">
                        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </span>
                </Button>
                {isOpen && (
                    <span
                        className={cn(
                            `w-full relative pl-[26px] flex flex-col text-[--sidebar-text-dropdown] [&>a]:relative [&>a]:mb-1 [&>a]:h-7 [&>a]:font-medium [&>a]:flex [&>a]:items-center [&>a:hover]:text-[--sidebar_text-dropdown-hover] [&>a:before]:inline-block [&>a:before]:content-[''] [&>a:before]:h-1 [&>a:before]:w-1  [&>a:before]:bg-[#e0e3e6] [&>a:before]:rounded-full [&>a:before]:mr-3 [&>a:after]:content-[''] [&>a:after]:bg-[#e0e3e6] [&>a:after]:h-7 [&>a:after]:w-px [&>a:after]:absolute [&>a:after]:left-[1.5px] [&>a:after]:top-[16px] [&>a:last-child:after]:hidden`,
                            {
                                "mb-[--spacing-items]": isOpen,
                            }
                        )}
                    >
                        {dropdown}
                    </span>
                )}
            </li>
        );
    }

    return (
        <li className="last:mb-0 mb-2">
            <NavLink
                end
                to={href as string}
                className={({ isActive }) => {
                    return `${cn(
                        `h-8 px-6 flex items-center rounded-md w-full  hover:text-[--sidebar-link-hover-text] !text-base gap-x-1 sidebarlink-hover font-medium ${
                            isActive
                                ? "text-[--sidebar-link-text-active]"
                                : "text-[--sidebar-link-text]"
                        }`,
                        {
                            "bg-[--bg-sidebar-link-active]": isActive,
                        }
                    )}`;
                }}
                onClick={onClick}
            >
                {icon}
                {title}
            </NavLink>
        </li>
    );
}
